import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CaminhaoService {
  constructor(private http: HttpClient) {}

  public GetCaminhaoByAgendamento(idAgendamento?: number): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    let url = `${environment.baseURL}Caminhao/GetCaminhaoByAgendamento`;

    if (!invalid.includes(idAgendamento)) {
      url += `?idAgendamento=${idAgendamento}`;
    }

    return this.http.get<any>(url);
  }
}
